class FreeGiftSection extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;

    this.addEventListener("submit", this.onSubmit.bind(this));
    this.addEventListener("change", this.onSubmit.bind(this));
  }

  async onSubmit(event) {
    event.preventDefault();
    const form = event.target.tagName === "FORM" ? event.target : event.target.closest("form");
    this.addFreeGift = event.type === "submit" ? true : false;
    const submitButton = form.querySelector('[type="submit"]');
    if (submitButton) if (submitButton.getAttribute("aria-disabled") === "true") return;
    this.handleErrorMessage(null, form);

    document.querySelector(`#shopify-section-${this.sectionId}`).classList.add("loading");
    if (submitButton) {
      submitButton.setAttribute("aria-disabled", true);
      submitButton.classList.add("loading");
      submitButton.querySelector(".loading-overlay__spinner").classList.remove("hidden");
    }

    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];

    const response = await this.UpdateCart(form);
    if (response.status) {
      this.handleErrorMessage(response.description, form);
    } else {
      const htmlText = response.sections[this.sectionId];
      const html = new DOMParser().parseFromString(htmlText, "text/html");
      const actionsEelements = html.querySelectorAll(`.product-card__actions, .section__footer-note`);
      Array.from(this.querySelectorAll(`.product-card__actions, .section__footer-note`)).forEach((element, index) => {
        element.innerHTML = actionsEelements[index].innerHTML;
      });
    }
    
    document.querySelector(`#shopify-section-${this.sectionId}`).classList.remove("loading");
    if (submitButton) {
      submitButton.classList.remove("loading");
      submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
      submitButton.removeAttribute('aria-disabled');
    }
  }

  async UpdateCart(form) {
    const url = this.addFreeGift === true ? `${routes.cart_add_url}.js` : `${routes.cart_update_url}`;
    const reBody = this.addFreeGift === true ? {
      items: [
        {
          id: form.querySelector("[name=id]").value,
          quantity: 1,
          properties: {
            _type: "free_gift",
          },
        }
      ],
    } : {
      updates: {
        [`${form.dataset.key}`]: 0,
      }
    };
    const response = await fetch(url, {
      body: JSON.stringify({
        ...reBody,
        sections: this.sectionId,
        sections_url: window.location.pathname,
      }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then((response) => response.json());

    return response;
  }

  handleErrorMessage(errorMessage = false, form) {
    this.errorMessageWrapper = this.errorMessageWrapper || form.querySelector(".free-gift-form__error-message-wrapper");
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".free-gift-form__error-message");

    this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
}

customElements.define("free-gift-section", FreeGiftSection);
